<template>
    <section-container title="Avarias" icon="car-crash">
        <div class="damages-list">
            <div
                v-for="(damage, label) in damages"
                :key="label"
                class="damage-item"
                :class="{'has-damage': hasDamage(damage)}"
                v-show="damage"
            >
                <div class="damage-label">
                    <i class="fas fa-car"></i> {{ label }}
                </div>
                <div class="damage-status">
                    <span v-if="damage">
                        {{ damage.description }}
                    </span>
                    <span v-else>N/A</span>
                </div>
            </div>
        </div>
    </section-container>
</template>

<script>
import SectionContainer from './SectionContainer.vue';

export default {
    name: "DamageList",
    components: {
        SectionContainer
    },
    props: {
        damages: {
            type: Object,
            required: true
        }
    },
    methods: {
        // hasDamage - verifica se uma área tem divergência
        hasDamage(damageData) {
            if (!damageData) return false;
            return damageData.id !== 1 && !!damageData.divergence;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Modals/Checklist/DamageList.vue